/* Clairvia motion layer */
(function () {
  if (window.__cvm) return; window.__cvm = true;
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var inEditor = window.Shopify && Shopify.designMode;

  function ready(fn) { d.readyState !== 'loading' ? fn() : d.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    root.classList.add('cvm-on');

    /* ---------- Hero title: words come into focus ---------- */
    var hero = d.querySelector('[id$="__hero_titre"] .rich-text__heading') ||
               d.querySelector('.rich-text__heading.h0, .rich-text__heading.h1');
    if (hero && !inEditor && !hero.dataset.cvm) {
      hero.dataset.cvm = '1';
      var words = hero.textContent.trim().split(/\s+/);
      hero.setAttribute('aria-label', hero.textContent.trim());
      hero.innerHTML = words.map(function (w, i) {
        var last = i === words.length - 1;
        return '<span class="cvm-w' + (last ? ' cvm-hl' : '') + '" style="--i:' + i + '" aria-hidden="true">' +
          w.replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }) + '</span>';
      }).join(' ');
      hero.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
      hero.classList.add('cvm-hero');
      if (!reduce) { var g = d.createElement('span'); g.className = 'cvm-glint'; g.setAttribute('aria-hidden', 'true'); hero.appendChild(g); }
    }

    /* ---------- Old price strike ---------- */
    d.querySelectorAll('[id$="__offre"] .rich-text__heading, [id$="__offre"] .rich-text__text').forEach(function (el) {
      el.innerHTML = el.innerHTML.replace(/(27[,.]00\s?€|€\s?27[.,]00)/, '<span class="cvm-strike">$1</span>');
    });

    /* ---------- Scroll progress ---------- */
    if (!reduce) {
      var bar = d.createElement('div'); bar.className = 'cvm-progress'; bar.setAttribute('aria-hidden', 'true');
      d.body.appendChild(bar);
      var ticking = false;
      var upd = function () {
        var h = root.scrollHeight - innerHeight;
        bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, scrollY / h) : 0) + ')';
        ticking = false;
      };
      addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
      upd();
    }

    /* ---------- Reveal on scroll ---------- */
    if (!('IntersectionObserver' in window) || inEditor) return;
    var TEXT = [
      '.title-wrapper-with-link', '.title-wrapper', '.rich-text__blocks > *',
      '.image-with-text__content > *', '.collapsible-content .accordion', '.collapsible-content .title-wrapper',
      '.product__info-container > *', '.multicolumn .title-wrapper-with-link'
    ];
    var GRID = ['.multicolumn-list__item'];
    var MEDIA = ['.image-with-text__media', '.multicolumn-card__image-wrapper', '.product__media-list > li:first-child .product__media'];
    var vh = innerHeight;
    var below = function (el) { var r = el.getBoundingClientRect(); return r.top > vh * 0.92; };
    var targets = [];
    var mark = function (el, cls, delay) {
      if (el.closest('[id$="__hero_titre"]') || el.dataset.cvmMark || !below(el)) return;
      el.dataset.cvmMark = '1';
      // our reveal replaces the theme's own one, so they never stack
      [el].concat(Array.prototype.slice.call(el.querySelectorAll('.scroll-trigger'))).forEach(function (n) {
        n.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
      });
      el.classList.add(cls);
      el.style.setProperty('--cvm-d', (delay || 0) + 'ms'); targets.push(el);
    };
    // a clipped element never reports as visible, so media are watched through their parent
    var watchOf = new Map();
    d.querySelectorAll(TEXT.join(',')).forEach(function (el) {
      var sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      mark(el, 'cvm-r', Math.min(sibs, 5) * 70);
    });
    d.querySelectorAll(GRID.join(',')).forEach(function (el) {
      var i = Array.prototype.indexOf.call(el.parentElement.children, el);
      mark(el, 'cvm-r', (i % 4) * 70);
    });
    d.querySelectorAll(MEDIA.join(',')).forEach(function (el) {
      var host = el.closest('.multicolumn-list__item');
      var i = host ? Array.prototype.indexOf.call(host.parentElement.children, host) : 0;
      mark(el, 'cvm-m', (i % 4) * 90 + 60);
    });
    d.querySelectorAll('.cvm-strike').forEach(function (el) { targets.push(el); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = watchOf.get(e.target) || e.target; el.classList.add('cvm-in');
        // hand the element back to the theme once it has landed
        if (!el.classList.contains('cvm-strike')) setTimeout(function () {
          el.classList.remove('cvm-r', 'cvm-m', 'cvm-in'); el.style.removeProperty('--cvm-d');
        }, 1700);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    targets.forEach(function (el) {
      var w = el.classList.contains('cvm-m') && el.parentElement ? el.parentElement : el;
      watchOf.set(w, el); io.observe(w);
    });

    /* ---------- Mouse-only details ---------- */
    if (!fine || reduce) return;
    // sheen on primary buttons
    d.querySelectorAll('.button--primary, .product-form__submit').forEach(function (b) {
      if (b.querySelector('.cvm-sheen')) return;
      var s = d.createElement('span'); s.className = 'cvm-sheen'; s.setAttribute('aria-hidden', 'true'); b.appendChild(s);
    });
    // gentle spring tilt on product images (decorative)
    d.querySelectorAll('.product__media-list > li:first-child .product__media, .image-with-text__media').forEach(function (el) {
      el.classList.add('cvm-tilt');
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = 0;
      var step = function () {
        cx += (tx - cx) * 0.12; cy += (ty - cy) * 0.12;
        el.style.transform = 'perspective(900px) rotateX(' + cy.toFixed(2) + 'deg) rotateY(' + cx.toFixed(2) + 'deg)';
        if (Math.abs(tx - cx) > 0.01 || Math.abs(ty - cy) > 0.01) raf = requestAnimationFrame(step); else raf = 0;
      };
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width - 0.5) * 6; ty = -((e.clientY - r.top) / r.height - 0.5) * 6;
        if (!raf) raf = requestAnimationFrame(step);
      });
      el.addEventListener('pointerleave', function () { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(step); });
    });
  });
})();

/* ---------- Surprise 3: add to cart — the product flies to the cart, the cart says thanks ---------- */
(function () {
  if (window.__cvatc) return; window.__cvatc = true;
  var d = document;
  var lang = (d.documentElement.lang || 'fr').slice(0, 2);
  var THANKS = { fr: 'Ajouté. Tes verres te remercient ✨', en: 'Added. Your glasses say thanks ✨', es: 'Añadido. Tus gafas te lo agradecen ✨' }[lang] || 'Added. Your glasses say thanks ✨';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function productImage() {
    var img = d.querySelector('.product__media img, .product-media-container img, .cart-item__image');
    return img ? (img.currentSrc || img.src) : '';
  }
  function cartIcon() { return d.getElementById('cart-icon-bubble'); }

  function fly(fromEl) {
    var icon = cartIcon(), src = productImage();
    if (!icon || !src || reduce) return;
    var a = fromEl.getBoundingClientRect(), b = icon.getBoundingClientRect();
    var sx = a.left + a.width / 2, sy = a.top + a.height / 2, ex = b.left + b.width / 2, ey = b.top + b.height / 2;
    var wx = d.createElement('div'); wx.className = 'cvatc-x';
    var wy = d.createElement('div'); wy.className = 'cvatc-y';
    var im = d.createElement('img'); im.className = 'cvatc-img'; im.src = src; im.alt = '';
    wy.appendChild(im); wx.appendChild(wy); d.body.appendChild(wx);
    wx.style.left = sx + 'px'; wx.style.top = sy + 'px';
    var dur = 650;
    window.__cvatcUntil = performance.now() + dur;
    // x moves evenly, y rises then drops: together they draw an arc
    wx.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + (ex - sx) + 'px)' }], { duration: dur, easing: 'cubic-bezier(.3,0,.7,1)', fill: 'forwards' });
    wy.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(' + (Math.min(sy, ey) - sy - 80) + 'px)', offset: .45 }, { transform: 'translateY(' + (ey - sy) + 'px)' }],
      { duration: dur, easing: 'ease-in-out', fill: 'forwards' });
    im.animate([{ transform: 'scale(.6)', opacity: 0 }, { transform: 'scale(1)', opacity: 1, offset: .15 }, { transform: 'scale(.35)', opacity: .9 }],
      { duration: dur, easing: 'cubic-bezier(.23,1,.32,1)', fill: 'forwards' });
    setTimeout(function () {
      wx.remove();
      icon.classList.remove('cvatc-hit'); void icon.offsetWidth; icon.classList.add('cvatc-hit');
    }, dur);
  }

  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var btn = f.querySelector('[type="submit"]') || f;
    if (btn.getAttribute('aria-disabled') === 'true') return;
    hook();
    window.__cvatcAt = performance.now();
    fly(btn);
  }, true);

  // the drawer waits for the product to land, then opens with a short thank-you inside
  function thank(drawer) {
    var wrap = drawer.querySelector('.drawer__cart-items-wrapper') || drawer.querySelector('cart-drawer-items');
    if (!wrap) return;
    var old = drawer.querySelector('.cvatc-thanks'); if (old) old.remove();
    var el = d.createElement('p'); el.className = 'cvatc-thanks'; el.setAttribute('role', 'status'); el.textContent = THANKS;
    wrap.insertAdjacentElement('afterbegin', el);
    var row = drawer.querySelector('.cart-item'); if (row && !reduce) { row.classList.remove('cvatc-glint'); void row.offsetWidth; row.classList.add('cvatc-glint'); }
  }
  function hook() {
    var drawer = d.querySelector('cart-drawer');
    if (!drawer || drawer.__cvatc || typeof drawer.open !== 'function') return;
    drawer.__cvatc = true;
    var open = drawer.open.bind(drawer);
    drawer.open = function (trigger) {
      var fresh = performance.now() - (window.__cvatcAt || -1e9) < 6000;
      var wait = (window.__cvatcUntil || 0) - performance.now();
      var go = function () { open(trigger); if (fresh) { window.__cvatcAt = -1e9; setTimeout(function () { thank(drawer); }, 220); } };
      if (wait > 0) setTimeout(go, wait + 90); else go();
    };
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', hook); else hook();
  addEventListener('load', hook);
})();
